var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLadyarrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 745.053,
    height: 534.414,
    viewBox: "0 0 745.053 534.414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_557",
    "data-name": "Group 557",
    transform: "translate(-1174.947 -1173.086)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_307",
    "data-name": "Group 307",
    transform: "translate(1380.583 1392.458)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1238",
    "data-name": "Path 1238",
    d: "M122.06,1154.671l46.372,206.162a6.623,6.623,0,0,0,11.593,2.732l31.9-39.025,3.655-4.467h0l.96-1.181,7.2-8.787a6.672,6.672,0,0,1,9.378-.923l42.274,35.037.923.775,140.74,116.742H616.311l-302.93-250.873a6.612,6.612,0,0,1-.886-9.3l25.623-31.345,1-1.181,8.787-10.744a6.615,6.615,0,0,0-5.095-10.818l-79.342-.3h0l-19.531-.074h0l-30.053-.111h-5.1l-12.479-.037h0l-8.086-.037h0l-21.82-.074-18.276-.074h0l-19.494-.074A6.541,6.541,0,0,0,122.06,1154.671Z",
    transform: "translate(-121.9 -1146.694)",
    fill: "#ed6b6c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_308",
    "data-name": "Group 308",
    transform: "translate(1667.124 1230.38)",
    opacity: 0.57
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1239",
    "data-name": "Path 1239",
    d: "M.083,711.946l21.155,94a3.475,3.475,0,0,0,6.092,1.44l19.42-23.74a3.5,3.5,0,0,1,4.91-.48L252.876,952.407V864.98L88.728,737.679a3.46,3.46,0,0,1-.48-4.874l15.58-19.051a3.485,3.485,0,0,0-2.658-5.686L3.517,707.7A3.529,3.529,0,0,0,.083,711.946Z",
    transform: "translate(0 -707.7)",
    fill: "#ffe5de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_355",
    "data-name": "Group 355",
    transform: "translate(1318.133 1173.086)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_317",
    "data-name": "Group 317",
    transform: "translate(88.012 17.31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1247",
    "data-name": "Path 1247",
    d: "M1226.442,599.4s3.323,7.458,15.174,4.947,27.505,6.166,21.894,13.7c-5.575,7.532,17.2,3.914,16.319,18.608s-11.408,26.583-32.859,18.719c-21.451-7.827-32.637-46.446-32.637-46.446Z",
    transform: "translate(-1214.332 -599.4)",
    fill: "#30262a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_318",
    "data-name": "Group 318",
    transform: "translate(43.018 17.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1248",
    "data-name": "Path 1248",
    d: "M1443.6,620.055c-8.566,2.732-25.29,7.458-25.29,7.458-.738-.665.812-28.613.812-28.613l-9.3.443s-8.971,34.077.3,40.944c9.489,7.052,31.936-2.474,31.936-2.474S1449.1,618.32,1443.6,620.055Z",
    transform: "translate(-1405.915 -598.9)",
    fill: "#ea9a81"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_319",
    "data-name": "Group 319",
    transform: "translate(54.081 45.59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1249",
    "data-name": "Path 1249",
    d: "M1479.75,682.756c.074,0,.111-.037.185-.074,1.366-2.031,1.145-6.313,1.145-6.5a.2.2,0,0,0-.406.037c0,.037.222,4.32-1.071,6.276a.2.2,0,0,0,.074.3C1479.676,682.756,1479.713,682.756,1479.75,682.756Z",
    transform: "translate(-1479.564 -676)",
    fill: "#e47e6a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_320",
    "data-name": "Group 320",
    transform: "translate(72.173 93.902)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1250",
    "data-name": "Path 1250",
    d: "M1335.245,817.1c-.812,3.249-14.214,6.5-30.385,2.806s-26.25-5.28-27.764-9.747c0,0,14.51-5.76,30.681-2.068C1323.911,811.781,1336.058,813.849,1335.245,817.1Z",
    transform: "translate(-1277.096 -806.854)",
    fill: "#30262a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_321",
    "data-name": "Group 321",
    transform: "translate(64.489 35.991)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1251",
    "data-name": "Path 1251",
    d: "M1283.65,674.257c-8.233-5.169-6.5-17.131-6.5-17.131a191.2,191.2,0,0,1,23.518-6.018A43.759,43.759,0,0,1,1309.31,650c29.388,0,33.487,66.346,33.6,67.6a241.189,241.189,0,0,0-58.223-6.35C1281.8,687.548,1283.355,675.438,1283.65,674.257Z",
    transform: "translate(-1277 -650)",
    fill: "#ea4747"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_322",
    "data-name": "Group 322",
    transform: "translate(64.604 36.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1252",
    "data-name": "Path 1252",
    d: "M1410.345,673.591s-8.787-10.375-11.445-16.023a98.884,98.884,0,0,1,20.786-6.867Z",
    transform: "translate(-1398.9 -650.7)",
    fill: "#ea4747"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_323",
    "data-name": "Group 323",
    transform: "translate(88.344 36.008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1253",
    "data-name": "Path 1253",
    d: "M1289.6,650.509s24.663-2.88,37.4,5.723l-15.913,12.405Z",
    transform: "translate(-1289.6 -650.046)",
    fill: "#ea4747"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_324",
    "data-name": "Group 324",
    transform: "translate(109.508 41.604)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1254",
    "data-name": "Path 1254",
    d: "M1287.1,677.866c1.551,2.1,6.5,1.218,11-1.957,4.541-3.175,6.941-7.458,5.39-9.562s-6.5-1.218-11,1.957C1287.944,671.479,1285.544,675.761,1287.1,677.866Z",
    transform: "translate(-1286.624 -665.203)",
    fill: "#30262a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_328",
    "data-name": "Group 328",
    transform: "translate(113.066 42.834)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_326",
    "data-name": "Group 326"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_325",
    "data-name": "Group 325"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1255",
    "data-name": "Path 1255",
    d: "M1235.061,731.47a171.72,171.72,0,0,0-27.69-45.264,47.161,47.161,0,0,0-5.944-6.2c-1.588-1.366-.812-5.649,1.661-8.307,2.326-2.511,6.793-3.618,7.716-2.991,1.588,1.034,3.692,3.323,6.941,6.941,11.3,12.627,19.272,26.878,28.391,50.876Z",
    transform: "translate(-1200.6 -668.533)",
    fill: "#ea9a81"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_327",
    "data-name": "Group 327",
    transform: "translate(33.058 55.848)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1256",
    "data-name": "Path 1256",
    d: "M1201.456,825.412a30.691,30.691,0,0,0-4.135-5.612s-8.972,2.289-9.23,3.138c-.591,1.994-.812,6.166-1.366,8.159-.221.886-.812,3.84.037,4.172.738.258,2.363-1.92,3.027-3.027,2.1,5.464,7.716,12.516,4.209.664h.037c.48,1.144,3.286,8.529,4.652,7.273,1.218-1.108-.628-6.719-1.4-8.639l.037-.037c.96,1.883,3.729,7.31,4.541,5.907,1.034-1.772-1.551-7.532-1.551-7.532s2.1,5.243,3.507,3.36c.96-1.292-1.071-5.39-1.957-7.163A2.9,2.9,0,0,0,1201.456,825.412Z",
    transform: "translate(-1186.318 -819.8)",
    fill: "#ea9a81"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_329",
    "data-name": "Group 329",
    transform: "translate(84.162 17.346)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1257",
    "data-name": "Path 1257",
    d: "M1367.9,623.313c3.4,1.551,9.341-2.289,11.851-5.169,0,0-3.249-.591-3.766-1.7a61.077,61.077,0,0,1-2.1-6.239v-1.071l-2.769-9.636-.7,9.525-.185,2.326v.111l-.184,2.437v.037l-.074.812-.111,1.625c-.111,1.329-.517,1.735-2.1,2.031C1367.828,618.4,1365.023,621.984,1367.9,623.313Z",
    transform: "translate(-1366.6 -599.5)",
    fill: "#ea9a81"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_330",
    "data-name": "Group 330",
    transform: "translate(87.733 209.368)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1258",
    "data-name": "Path 1258",
    d: "M1349.239,1119.6s-.111,4.024-2.954,5.132c-2.843,1.145-11.113,2.141-8.012,4.726,1.772,1.477,10.116.517,12.442.517,2.363,0,4.578.96,6.313-.517,1.92-1.661,0-9.858,0-9.858a9.911,9.911,0,0,1-3.84.96A7.794,7.794,0,0,1,1349.239,1119.6Z",
    transform: "translate(-1337.589 -1119.6)",
    fill: "#30262a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_331",
    "data-name": "Group 331",
    transform: "translate(135.507 209.368)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1259",
    "data-name": "Path 1259",
    d: "M1219.839,1119.6s-.111,4.024-2.954,5.132c-2.843,1.145-11.113,2.141-8.012,4.726,1.772,1.477,10.116.517,12.442.517,2.363,0,4.578.96,6.313-.517,1.92-1.661,0-9.858,0-9.858a9.911,9.911,0,0,1-3.84.96A7.975,7.975,0,0,1,1219.839,1119.6Z",
    transform: "translate(-1208.189 -1119.6)",
    fill: "#30262a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_332",
    "data-name": "Group 332",
    transform: "translate(78.19 99.458)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1260",
    "data-name": "Path 1260",
    d: "M1325.771,821.938a2.38,2.38,0,0,0-2.326,2.4c.074,5.649.7,21.377,5.1,46.593,4.061,23.223,8.861,46.63,11.187,57.854a9.111,9.111,0,0,0,8.6,7.126l2.252.074a7.518,7.518,0,0,0,7.9-7.975L1352.8,852.1s9.452-26.361,3.1-27.986C1346.926,821.827,1331.6,821.827,1325.771,821.938Z",
    transform: "translate(-1323.444 -821.902)",
    fill: "#a74c3b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_333",
    "data-name": "Group 333",
    transform: "translate(88.455 99.457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1261",
    "data-name": "Path 1261",
    d: "M1202.393,821.9l51.541,108.361c1.994,4.43,22,6.9,17.2-4.837l-28.576-97.285c-.443-1.181-11.408-3.027-12.553-3.36C1223.807,822.971,1202.393,821.9,1202.393,821.9Z",
    transform: "translate(-1202.393 -821.9)",
    fill: "#a74c3b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_334",
    "data-name": "Group 334",
    transform: "translate(88.187 108.936)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1262",
    "data-name": "Path 1262",
    d: "M1356.005,880.332h.111c.148-.037.185-.185.148-.332l-6.9-17.722a28.144,28.144,0,0,0-8.418-11.925,15.508,15.508,0,0,0-4.837-2.769.269.269,0,0,0-.148.517c.074.037,8.2,2.547,12.922,14.362l6.9,17.722A.249.249,0,0,0,1356.005,880.332Z",
    transform: "translate(-1335.764 -847.575)",
    fill: "#020202"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_339",
    "data-name": "Group 339"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_335",
    "data-name": "Group 335",
    transform: "translate(48.591 13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1263",
    "data-name": "Path 1263",
    d: "M1448.453,598.35l-22.927-3.877a2.142,2.142,0,0,1-1.772-2.474l.406-2.474a2.142,2.142,0,0,1,2.474-1.772l22.927,3.877a2.142,2.142,0,0,1,1.772,2.474l-.406,2.474A2.181,2.181,0,0,1,1448.453,598.35Z",
    transform: "translate(-1423.727 -587.727)",
    fill: "#a74c3b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_336",
    "data-name": "Group 336",
    transform: "translate(34.253 8.704)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1264",
    "data-name": "Path 1264",
    d: "M1484.236,590.937l-22.115-3.729a2.812,2.812,0,0,1-2.289-3.249l.923-5.538a2.812,2.812,0,0,1,3.249-2.289l22.115,3.729a2.812,2.812,0,0,1,2.289,3.249l-.923,5.538A2.852,2.852,0,0,1,1484.236,590.937Z",
    transform: "translate(-1459.792 -576.093)",
    fill: "#ea4747"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_337",
    "data-name": "Group 337",
    transform: "translate(3.429 1.952)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1265",
    "data-name": "Path 1265",
    d: "M1546,577.925l-35.074-5.907a2.3,2.3,0,0,1-1.883-2.658l1.625-9.636a2.3,2.3,0,0,1,2.658-1.883l35.074,5.907a2.3,2.3,0,0,1,1.883,2.658l-1.625,9.636A2.3,2.3,0,0,1,1546,577.925Z",
    transform: "translate(-1509.005 -557.805)",
    fill: "#a74c3b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_338",
    "data-name": "Group 338"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1266",
    "data-name": "Path 1266",
    d: "M1613.123,569.42l-1.735-.3a1.735,1.735,0,0,1-1.44-2.031l2.215-13.107a1.735,1.735,0,0,1,2.031-1.44l1.735.3a1.735,1.735,0,0,1,1.44,2.031l-2.215,13.107A1.781,1.781,0,0,1,1613.123,569.42Z",
    transform: "translate(-1609.917 -552.516)",
    fill: "#ea4747"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_341",
    "data-name": "Group 341",
    transform: "translate(47.927 8.553)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_340",
    "data-name": "Group 340"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1267",
    "data-name": "Path 1267",
    d: "M1477.981,575.911s-2.363-1-3.286,1.181c-1.145,2.769.074,7.31.813,5.575a16.687,16.687,0,0,0,.96-3.286s-.849,5.5.48,5.28c1.366-.221,2.1-4.726,2.1-4.726s-.369,5.28.849,4.615c1.219-.628,1.772-3.766,1.772-3.766s-.554,4.246.849,3.471c1.366-.775,1.108-3.914,1.329-5.28.185-1.292-.591-1.809-1.846-1.92a3.581,3.581,0,0,0-2.031-.665c-.332.074-.591-.258-.812-.332C1478.794,575.985,1477.981,575.911,1477.981,575.911Z",
    transform: "translate(-1474.226 -575.683)",
    fill: "#ea9a81"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_342",
    "data-name": "Group 342",
    transform: "translate(87.679 28.644)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1268",
    "data-name": "Path 1268",
    d: "M1382.4,633.2a9.677,9.677,0,0,0,3.8-3.1h-.3l-3.323.665Z",
    transform: "translate(-1382.4 -630.1)",
    fill: "#30262a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_343",
    "data-name": "Group 343",
    transform: "translate(93.576 17.31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1269",
    "data-name": "Path 1269",
    d: "M1365.546,599.4s-.628,1.477-.148,4.8c.665,4.8-5.169,6.018-6.387,4.5-.148-.185,1.255-8.049,1.255-8.049l1.92-.775Z",
    transform: "translate(-1359 -599.4)",
    fill: "#30262a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_344",
    "data-name": "Group 344",
    transform: "translate(78.605 7.821)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1270",
    "data-name": "Path 1270",
    d: "M1366.262,583.446c.886-6.018,5.8-10.375,10.928-9.673s8.566,6.129,7.679,12.147-5.8,10.375-10.928,9.673C1368.81,594.929,1365.376,589.464,1366.262,583.446Z",
    transform: "translate(-1366.123 -573.699)",
    fill: "#ea9a81"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_345",
    "data-name": "Group 345",
    transform: "translate(78.487 6.123)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1271",
    "data-name": "Path 1271",
    d: "M1365.055,572.9c.222.369-2.1,5.8,8.639,8.6s6.055-10.707-1.994-12.073c-11.593-1.957-14.4,5.243-13.661,8.086S1365.055,572.9,1365.055,572.9Z",
    transform: "translate(-1357.93 -569.1)",
    fill: "#30262a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_346",
    "data-name": "Group 346",
    transform: "translate(93.328 16.571)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1272",
    "data-name": "Path 1272",
    d: "M1364.17,597.4s3.8,5.1,1.551,9.452c0,0,2.99-2.363,3.212-3.36a35.3,35.3,0,0,0,.074-4.726Z",
    transform: "translate(-1364.17 -597.4)",
    fill: "#30262a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_347",
    "data-name": "Group 347",
    transform: "translate(92.268 17.576)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1273",
    "data-name": "Path 1273",
    d: "M1370.636,604.064a2.118,2.118,0,1,1,1-3.175A2.408,2.408,0,0,1,1370.636,604.064Z",
    transform: "translate(-1367.028 -600.121)",
    fill: "#ea9a81"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_349",
    "data-name": "Group 349",
    transform: "translate(87.005 18.293)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_348",
    "data-name": "Group 348"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1274",
    "data-name": "Path 1274",
    d: "M1386.911,602.556c-.074-.037-.111-.074-.111-.148a.21.21,0,0,1,.148-.258,2.423,2.423,0,0,1,2.658.96.211.211,0,0,1-.332.258,3.644,3.644,0,0,0-2.215-.775A.221.221,0,0,1,1386.911,602.556Z",
    transform: "translate(-1386.791 -602.063)",
    fill: "#080435"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_351",
    "data-name": "Group 351",
    transform: "translate(80.144 17.542)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_350",
    "data-name": "Group 350"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1275",
    "data-name": "Path 1275",
    d: "M1405.121,600.9c-.074,0-.111-.037-.185-.074a.228.228,0,0,1,.037-.3,2.394,2.394,0,0,1,2.843-.074.2.2,0,0,1,.074.3.232.232,0,0,1-.3.074,3.906,3.906,0,0,0-2.363.074C1405.195,600.867,1405.158,600.9,1405.121,600.9Z",
    transform: "translate(-1404.896 -600.029)",
    fill: "#080435"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_352",
    "data-name": "Group 352",
    transform: "translate(81.019 19.908)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1276",
    "data-name": "Path 1276",
    d: "M1408.367,607.125a.8.8,0,0,1-.369,1.034.765.765,0,0,1-.886-.665.8.8,0,0,1,.369-1.034A.765.765,0,0,1,1408.367,607.125Z",
    transform: "translate(-1407.06 -606.437)",
    fill: "#080435"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_353",
    "data-name": "Group 353",
    transform: "translate(82.326 23.734)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1277",
    "data-name": "Path 1277",
    d: "M1391.8,616.8s.369,2.917,2.658,3.064c2.437.148,3.027-2.4,3.027-2.4S1394.163,618.129,1391.8,616.8Z",
    transform: "translate(-1391.8 -616.8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_354",
    "data-name": "Group 354",
    transform: "translate(86.978 20.973)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1278",
    "data-name": "Path 1278",
    d: "M1389.591,610.016c.037,0,.074-.037.111-.037.037-.037,0-.111-.037-.148a3.7,3.7,0,0,0-2.732-.406c-.074,0-.074.074-.074.148s.074.074.148.074a3.764,3.764,0,0,1,2.584.406C1389.554,610.016,1389.554,610.016,1389.591,610.016Z",
    transform: "translate(-1386.859 -609.323)",
    fill: "#020202"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_356",
    "data-name": "Group 356",
    transform: "translate(1174.947 1503.109)",
    opacity: 0.44
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1279",
    "data-name": "Path 1279",
    d: "M1484.411,1650.789H1370L1235.68,1539.438a3.167,3.167,0,0,0-4.467.443l-26.4,32.268a3.174,3.174,0,0,1-5.538-1.292l-17.168-76.388h0l-.258-1.181-9.673-43.049a3.138,3.138,0,0,1,3.1-3.84l125.381.48a3.161,3.161,0,0,1,2.437,5.169l-21.635,26.472a3.123,3.123,0,0,0,.443,4.43Z",
    transform: "translate(-1172.1 -1446.399)",
    fill: "#d3a09f"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLadyarrow);
export default __webpack_public_path__ + "static/media/ladyarrow.5c31b06b50fd1771c4d7c888ef1bbf64.svg";
export { ForwardRef as ReactComponent };